import type { ErrorField } from '../components/organisms/ApplicationForm/applicationFormTypes'

// The tabs of the application page, in order. Adding a tab = one line here, one line in FIELD_TAB
// for each of its fields that can carry an error, and its organism in ApplicationForm.
export const APPLICATION_TABS = [
  { id: 'general', labelKey: 'applications.tabs.general' },
  { id: 'accesses', labelKey: 'applications.tabs.accesses' },
  { id: 'version', labelKey: 'applications.tabs.version' },
  { id: 'notifications', labelKey: 'applications.tabs.notifications' },
] as const

export type ApplicationTabId = (typeof APPLICATION_TABS)[number]['id']

// Which tab holds each field that can show an error
export const FIELD_TAB: Record<ErrorField, ApplicationTabId> = {
  name: 'general',
  minVersion: 'version',
  latestVersion: 'version',
  storeUrlAndroid: 'version',
  storeUrlIos: 'version',
  apiBaseUrl: 'version',
  imageBaseUrl: 'version',
}

export const DEFAULT_APPLICATION_TAB: ApplicationTabId = APPLICATION_TABS[0].id

export function isApplicationTabId(value: string | null | undefined): value is ApplicationTabId {
  return APPLICATION_TABS.some(tab => tab.id === value)
}
